// How to reach Neomaris, in one place (TOM-98). /support, /contact, /privacy and
// the footer all read these, so a change here changes every page.

/** The one monitored inbox (Mike, TOM-98). The cloud's contact route sends here too. */
export const SUPPORT_EMAIL = 'support@tombolomarine.com';

/** Where Neomaris is based. City and state only; no street address is published. */
export const SUPPORT_LOCATION = 'Seattle, WA';

/** The reply time we promise. Kept modest on purpose; change it here. */
export const SUPPORT_RESPONSE_TIME = 'We aim to reply within two business days.';
